var r=50,a=10,e=1.1;export{a as LABEL_FONT_SIZE,e as LABEL_LINE_HEIGHT,r as ROW_HEIGHT};
